import MainPage from './pages/MainPage';
import {
  BrowserRouter as Router,
  Route
} from "react-router-dom";
import {Provider as MainProvider} from './context/MainContext';
import './App.css';

function App() {
  return (
    <div className="App">
    <link
      rel="stylesheet"
      href="https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
      integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
      crossOrigin="anonymous"
    />
    <MainProvider>
      <Router>
        <Route
          path={['/:awbData/:loginData', '/:awbData']}
          render={props => <MainPage {...props} />}
        />
      </Router>
    </MainProvider>
    </div>
  );
}

export default App;
